// extracted by mini-css-extract-plugin
export var aipInsuranceContainer = "footer-module--aipInsuranceContainer--82ffb";
export var almaLeaf = "footer-module--almaLeaf--2a77a";
export var disclaimer = "footer-module--disclaimer--74299";
export var footerText = "footer-module--footerText--a2d42";
export var infoContainer = "footer-module--infoContainer--1a4bf";
export var infoTitle = "footer-module--infoTitle--30be8";
export var leafLine = "footer-module--leafLine--531d1";
export var line = "footer-module--line--697fb";
export var links = "footer-module--links--62dc4";
export var linksColumn = "footer-module--linksColumn--19949";
export var linksColumnContainer = "footer-module--linksColumnContainer--fa5ea";
export var linksContainer = "footer-module--linksContainer--f6104";
export var moduleContainer = "footer-module--moduleContainer--70b0c";
export var otherInsuranceContainer = "footer-module--otherInsuranceContainer--1eb6b";
export var policyLink = "footer-module--policyLink--f5b32";
export var policyLinksContainer = "footer-module--policyLinksContainer--d014a";
export var socialIcons = "footer-module--socialIcons--f5ebd";
export var socialLinks = "footer-module--socialLinks--59e9b";
export var socialLinksMobile = "footer-module--socialLinksMobile--d2b32";
export var state = "footer-module--state--93a37";
export var statesContainer = "footer-module--statesContainer--61708";
export var title = "footer-module--title--ef13d";
export var toggleContainer = "footer-module--toggleContainer--e7f2c";
export var toggleTitle = "footer-module--toggleTitle--0baf4";